























import { Component, Vue } from 'vue-property-decorator'
import { TagsViewModule } from '@/store/modules/tags-view'
import AcceptPopup from "@/views/accept/index.vue"
import ShareService from "@/services/share-service";
import ImportPopup from "@/views/import/index.vue"
import shareService from '@/services/share-service';

@Component({
  name: 'AppMain',
  components: {
    AcceptPopup,
    ImportPopup
  }
})
export default class extends Vue {

  shareService = ShareService;

  get cachedViews() {
    return TagsViewModule.cachedViews
  }

  get key() {
    return this.$route.path
  }

}
